import { render } from "./InstructorExpertise.vue?vue&type=template&id=45e862a2&scoped=true"
import script from "./InstructorExpertise.vue?vue&type=script&lang=js"
export * from "./InstructorExpertise.vue?vue&type=script&lang=js"

import "./InstructorExpertise.vue?vue&type=style&index=0&id=45e862a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e862a2"]])

export default __exports__